export default __webpack_public_path__ + "static/media/whiteLinkedIn.09793cff.svg";